import { render, staticRenderFns } from "./viewProjectStage.vue?vue&type=template&id=fef5993a"
import script from "./viewProjectStage.vue?vue&type=script&lang=js"
export * from "./viewProjectStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fef5993a')) {
      api.createRecord('fef5993a', component.options)
    } else {
      api.reload('fef5993a', component.options)
    }
    module.hot.accept("./viewProjectStage.vue?vue&type=template&id=fef5993a", function () {
      api.rerender('fef5993a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/education/viewProjectStage.vue"
export default component.exports